import styled from "styled-components";
import { EBreakpoints } from "@ddm-design-system/tokens";
import NavigationMenu from "../common/navigation_menu/NavigationMenu";

export const HomeContainer = styled.div`
  display: flex;
  margin: 0 auto;
  max-width: 1440px;
  min-height: 100vh;
`;

export const NavigationMenuStyled = styled(NavigationMenu)`
  flex: 0;
`;

export const ScrollToTopContainer = styled.div`
  flex: 1;
  padding: ${({ theme }) => theme.spaceUnit.lg} ${({ theme }) => theme.spaceUnit.lg} 0;
  overflow: auto;
  width: 100vw;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.breakpoints[EBreakpoints.MOBILE1]}px) {
    padding: ${({ theme }) => theme.spaceUnit.lg} ${({ theme }) => theme.spaceUnit.md}
      ${({ theme }) => theme.spaceUnit.md} ${({ theme }) => theme.spaceUnit.md};
    overflow: unset;
  }
`;
